<template>
  <router-view/>
</template>

<script setup>
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

const store = useStore();
const {locale} = useI18n({useScope: 'global'})

onMounted(async () => {
    const language = store.state.language
    locale.value = language
    console.log(language);
});
</script>